"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var report_builder_html_1 = __importDefault(require("./report-builder.html"));
var report_builder_controller_1 = __importDefault(require("./report-builder.controller"));
var create_report_module_1 = __importDefault(require("./create-report/create-report.module"));
var edit_report_module_1 = __importDefault(require("./edit-report/edit-report.module"));
function getReportBuilderConfig(ReportBuilder) {
    return ReportBuilder.getReportBuilderConfig().then(function (response) {
        return response.data;
    });
}
getReportBuilderConfig.$inject = ["ReportBuilder"];
function config($stateProvider, $urlRouterProvider) {
    $stateProvider.state("drivecoach.admin.reportbuilder", {
        url: "/report-builder",
        controller: "ReportBuilderController",
        controllerAs: "vm",
        template: report_builder_html_1.default,
        resolve: {
            reportBuilderConfig: getReportBuilderConfig,
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider"];
exports.default = angular_1.default
    .module("drivecoach.admin.reportbuilder", [
    create_report_module_1.default.name,
    edit_report_module_1.default.name,
])
    .config(config)
    .controller("ReportBuilderController", report_builder_controller_1.default);
